'use strict';

define('map',['jquery', 'select2'], function ($) {

  var
    IMG_PATH                    = (window.location.href.indexOf('127.0.0.1') > -1 || window.location.href.indexOf('192.168') > -1 ? '' : '/static') +  '/dist/images/map-markers/',
    FILTER_ADDRESS_ID           = 'map__filter-address',
    DETAILS_INFO_BOX_OVERLAY_ID = 'map__info-box-details-overlay',
    DETAILS_INFO_BOX_ID         = 'map__info-box-details';

  var
    centers = [],
    center_types = [],
    markers = [],
    colors_legend = [],

    hide_centers_filter;

  var
    user_coords = {
      lat: 0,
      lng: 0
    };

  var
    $overlay,
    $info_box_details,
    active_marker,
    infobox;

  var
    mapOptions = {
      disableDoubleClickZoom: true,
      center: {
        lat: 56,
        lng: 10
      },
      zoom: 6
    };

  var
    mapData = window.mapData || '';

  var
    gmaps,
    map,
    geocoder,
    searchBox;

  var
    $body = $('body');

  /**
  * Events handlers
  */
  var
    handlers = {
      openInfoBoxDetails: function() {
        fillInfoBoxDetailsWithData();
        $info_box_details.show();
        $overlay.show();
        return false;
      },
      
      closeInfoBoxDetails: function() {
        $info_box_details.hide();
        $overlay.hide();
        return false;
      },

      doNothing: function() {
        return false;
      }
    };

  /**
  * Format option for the select
  */
  var formatOption = function(opt) {
    var option;

    if(!opt.id) {
      return '';
    }

    option = '<span style="white-space: nowrap">' + renderCenterTypeImg(opt.id, true) + opt.text + '</span>';
    return option;
  };

  /**
  * Address input has been changed
  */
  var placesChanged = function() {
    var
      places = searchBox.getPlaces(),
      place;

    if(!places.length) {
      return;
    }

    place = places[0];

    map.setZoom(11);
    map.setCenter(place.geometry.location);
  };


  /**
  * Init filter
  */
  var initFilter = function() {
    
    if(!hide_centers_filter) {
      renderSelect();
      customizeSelect();
    }
    else {
      $('.map__filter .select-holder').remove();
    }

    $('.map__filter').addClass('js-filter-inited');

    function customizeSelect() {
      $('#filter-center-type').select2({
        formatResult: formatOption,
        formatSelection: formatOption,
        minimumResultsForSearch: -1
      });
    }

    function renderSelect() {
      var
        $select_html = $('<select />', {id: 'filter-center-type'}), i;

      $select_html.append('<option>' + dictionary.seeAllCenters + '</option>');
      for(i in center_types) {
        $select_html.append('<option value="' + i + '" data-color="' + center_types[i].color + '">' + center_types[i].name + '</option>');
      }

      $('.map__filter .select-holder').append($select_html);
    }
  };

  /**
  * Fill the data to the info box with details 
  */
  var fillInfoBoxDetailsWithData = function() {

    /*jshint multistr: true */
    var
        info_box_details_content_tpl = ' \
          <div class="map__info-box-details__left-col"> \
          {{image_box}} \
            <div class="map__info-box-address"> \
              <p>{{address}}</p> \
              <p>{{phones}}</p> \
            </div> \
            <div class="map__info-box-openning-hours"> \
              {{opening_hours}} \
            </div> \
          </div> \
          {{contact_div}} \
          <a href="#" class="icon as3-icon_close" title="Close"></a>';

    var
      image_url,
      address         = active_marker.center.override_address ? active_marker.center.display_address : active_marker.center.address,
      image_type      = active_marker.center.image_type ? active_marker.center.image_type : 'gmap',
      image           = active_marker.center.image,
      opening_hours  = active_marker.center.opening_hours,
      contact_details = active_marker.center.contact_details,
      phones          = active_marker.center.phones;
    
    $info_box_details.removeClass('map__info-box-details-single-column');
    $info_box_details.removeClass('map__info-box-details');
    if(contact_details === "")
    {
      info_box_details_content_tpl = info_box_details_content_tpl.replace('{{contact_div}}', '');
      $info_box_details.addClass('map__info-box-details-single-column');
    }
    else
    {
      var details_tpl = ' \
          <div class="map__info-box-details__right-col"> \
            <div class="map__info-box-contact-details"> \
              {{contact_details}} \
            </div> \
          </div>';
      info_box_details_content_tpl = info_box_details_content_tpl.replace('{{contact_div}}', details_tpl);
      $info_box_details.addClass('map__info-box-details');
    }

    var image_exists = true;
    if (!image_type || image_type === "gmap"){
      image_url = getImageUrl(active_marker.center.coords, 355, 150);
    }
    else if (image_type === "selected" && image.large_url !== ""){
      image_url = image.large_url;
    }
    else if (image_type === "no-image" || image.large_url === ""){
      image_url = "";
      image_exists = false;
    }

    if (image_exists){
      var image_tpl = ' \
      <div class="map__info-box-img"> \
        <img src="{{image_url}}" /> \
      </div>';
      info_box_details_content_tpl = info_box_details_content_tpl.replace('{{image_box}}', image_tpl);
    }
    else{
      info_box_details_content_tpl = info_box_details_content_tpl.replace('{{image_box}}', '');
    }
    
    var
      info_box_details_content = info_box_details_content_tpl.replace('{{image_url}}', image_url);


    info_box_details_content = info_box_details_content.replace('{{address}}', address);
    info_box_details_content = info_box_details_content.replace('{{opening_hours}}', opening_hours || '');
    info_box_details_content = info_box_details_content.replace('{{phones}}', phones || '');
    info_box_details_content = info_box_details_content.replace('{{contact_details}}', contact_details || '');

    $info_box_details.html(info_box_details_content);
  };

  /**
  * Get image url
  */
  var getImageUrl = function(coords, w, h) {
    var
      image_url_tpl = 'https://maps.googleapis.com/maps/api/streetview?key=AIzaSyAx0g1a_EqjsxT1533Po0f0-gqg8a5RhYU&size=' + (w || 280) + 'x' + (h || 130) + '&location={{lat}},{{lng}}',
      image_url;

    image_url = image_url_tpl.replace('{{lat}}', coords.lat);
    image_url = image_url.replace('{{lng}}', coords.lng);

    return image_url;
  };

  /**
  * Get direction url
  */
  var getDirUrl = function(coords) {
    var
      get_dir_url_tpl, get_dir_url;

    if(user_coords.lat) {
      get_dir_url_tpl = 'https://www.google.com/maps/dir/{{user_lat}},{{user_lng}}/{{lat}},{{lng}}';
      get_dir_url = get_dir_url_tpl.replace('{{user_lng}}', user_coords.lng);
      get_dir_url = get_dir_url.replace('{{user_lat}}', user_coords.lat);
    }
    else {
      get_dir_url_tpl = 'https://www.google.com/maps?daddr={{lat}},{{lng}}';
      get_dir_url = get_dir_url_tpl;
    }

    get_dir_url = get_dir_url.replace('{{lng}}', coords.lng);
    get_dir_url = get_dir_url.replace('{{lat}}', coords.lat);

    return get_dir_url;
  };

  /**
  * Get info box content
  */
  var getInfoBoxContent = function(data) {

    var
      coords  = data.coords || '',
      address = data.address || '',
      image_type = data.image_type || '',
      image = data.image || '',
      phones  = data.phones || '',
      details  = data.details || '',
      opening_hours  = data.opening_hours || '',
      no_directions  = data.no_directions || '';
    
    /*jshint multistr: true */
    var
      info_box_content_html_tpl = ' \
        <div class="map__info-box"> \
        {{image_box}} \
          <div class="map__info-box-content"> \
            <div class="map__info-box-address{{directionsclass}}"> \
              <p>{{address}}</p> \
              <p>{{phones}}</p> \
              {{readmorebutton}} \
            </div> \
            {{directionsbutton}} \
          </div> \
        </div>';
    
    if (details === "" && opening_hours === ""){
      info_box_content_html_tpl = info_box_content_html_tpl.replace('{{readmorebutton}}', '');
    }
    else{
      info_box_content_html_tpl = info_box_content_html_tpl.replace('{{readmorebutton}}', '<p><a href="#" class="map__info-box-link map__info-box-read-more" onClick="readMore(event)">' + dictionary.readmore + '</a></p>');
    }
    if (no_directions){
      info_box_content_html_tpl = info_box_content_html_tpl.replace('{{directionsbutton}}', '');
      info_box_content_html_tpl = info_box_content_html_tpl.replace('{{directionsclass}}', '');
    }
    else{
      info_box_content_html_tpl = info_box_content_html_tpl.replace('{{directionsbutton}}', '<p><a target="_blank" href="{{get_directions_url}}" class="map__info-box-link">' + dictionary.getDirections + '</a></p>');
      info_box_content_html_tpl = info_box_content_html_tpl.replace('{{directionsclass}}', '-first');
    }
    
    var
      info_box_content_html,
      image_url, get_dir_url;

    var image_exists = true;
    if (!image_type || image_type === "gmap"){
      image_url = getImageUrl(coords);
    }
    else if (image_type === "selected" && image.small_url !== ""){
      image_url = image.small_url;
    }
    else if (image_type === "no-image" || image.small_url === ""){
      image_url = "";
      image_exists = false;
    }

    if (image_exists){
      var image_tpl = ' \
      <div class="map__info-box-img"> \
        <img src="{{image_url}}" /> \
      </div>';
      info_box_content_html_tpl = info_box_content_html_tpl.replace('{{image_box}}', image_tpl);
    }
    else{
      info_box_content_html_tpl = info_box_content_html_tpl.replace('{{image_box}}', '');
    }

    get_dir_url = getDirUrl(coords);

    info_box_content_html = info_box_content_html_tpl.replace('{{image_url}}', image_url);
    info_box_content_html = info_box_content_html.replace('{{address}}', address);
    info_box_content_html = info_box_content_html.replace('{{phones}}', phones);
    info_box_content_html = info_box_content_html.replace('{{get_directions_url}}', get_dir_url);

    return info_box_content_html;
  };

  window.readMore = function (event) {
    handlers.openInfoBoxDetails();
  }

  /**
  * Add markers to the map
  */
  var addMarkers = function() {

    var
      marker;

    infobox = new InfoBox({
      content: 'Loading...',
      alignBottom: true,
      pixelOffset: new google.maps.Size(-140, -130),
      enableEventPropagation: false,
      pane: 'floatPane'
    });

    for(var i in centers) {
      addMarker(centers[i]);
    }

    function addMarker(c) {
      var
        info_box_content_html;

      marker = new gmaps.Marker({
        map:       map,
        position:  c.coords,
        icon:      IMG_PATH + colors_legend[c.center_type.color] + '.png',
        draggable: false
      });

      marker.center = c;

      gmaps.event.addListener(marker, 'click', function(event) {
          active_marker = this;

          info_box_content_html = getInfoBoxContent({
            coords:  active_marker.center.coords,
            address: active_marker.center.override_address ? active_marker.center.display_address : active_marker.center.address,
            image_type:   active_marker.center.image_type ? active_marker.center.image_type : 'gmap',
            image:   active_marker.center.image,
            phones:  active_marker.center.phones,
            details: active_marker.center.contact_details,
            opening_hours: active_marker.center.opening_hours,
            no_directions: active_marker.center.disable_directions
          });


          infobox.setContent(info_box_content_html);
          infobox.open(map, active_marker);
      });


      markers.push(marker);
    }

  };

  /**
  * Fit markers on the map
  */
  var fitMarkers = function() {
    var
      bounds = new google.maps.LatLngBounds(),
      len = markers.length;

    for(var i = 0; i < len; ++i) {
      bounds.extend(markers[i].getPosition());
    }

    if(len === 1) {
      map.setCenter(markers[0].getPosition());
      map.setZoom(8);
    }
    else if(len > 1) {
      map.fitBounds(bounds);
    }
  };

  var renderCenterTypeImg = function(i, is_small) {
    if(center_types[i]) {
      return '<img src="' + IMG_PATH + colors_legend[center_types[i].color] + (is_small ? '-small' : '') + '.png" />';
    }
    else {
      return '<img src="' + IMG_PATH + 'all-small.png" style="margin-left:-5px" />';
    }
  };

  var renderCenterTypeList = function() {
    var
      html = '<ul>';
    for(var i in center_types) {
      html += '<li>' + renderCenterTypeImg(i, true) +  center_types[i].name  + '</li>';
    }
    html += '</ul>';
    $('.map__center-types').append(html);
  };

  var initSearchBox = function() {
    var
      address_input;

    address_input = document.getElementById(FILTER_ADDRESS_ID);
    searchBox     = new gmaps.places.SearchBox(address_input);
    gmaps.event.addListener(searchBox, 'places_changed', placesChanged);
  };

  var filterByCenterType = function() {
    var
      selected_center_type = parseInt($('#filter-center-type option:selected').attr('data-color'), 10),
      i;

    infobox.close();
    for(i in markers) {
      if(isNaN(selected_center_type) || markers[i].center.center_type.color === selected_center_type) {
        markers[i].setVisible(true);
      }
      else {
        markers[i].setVisible(false);
      }
    }
    return false;
  };

  /**
  * Build the map
  */
  var initialize = function() {
    if(!mapData) {
      return false;
    }


    getUserLocation();
    getData();
    initFilter();

    gmaps    = google.maps;
    map      = new gmaps.Map(document.getElementById('map-box'), mapOptions);
    geocoder = new gmaps.Geocoder();

    addMarkers();
    fitMarkers();
    renderCenterTypeList();
    initSearchBox();
    buildDetailedInfoBox();
    attachEvents();
  };

  var getUserLocation = function() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        var
          latitude = position.coords.latitude,
          longitude = position.coords.longitude;

        user_coords = {
          lat: latitude,
          lng: longitude
        };

      });
    }
  };

  var buildDetailedInfoBox = function() {
    $overlay = $('<div />', { id: DETAILS_INFO_BOX_OVERLAY_ID, class: 'map__info-box-details-overlay'});
    $info_box_details = $('<div />', {id: DETAILS_INFO_BOX_ID, class: 'map__info-box-details'});
    $body.append($overlay);
    $body.append($info_box_details);
  };

  var attachEvents = function() {
    $body.on('click', '#' + DETAILS_INFO_BOX_OVERLAY_ID, handlers.closeInfoBoxDetails);
    $('#' + DETAILS_INFO_BOX_ID).on('click', '.as3-icon_close', handlers.closeInfoBoxDetails);
    $('#filter-center-type').on('change', filterByCenterType);
    $('.map__search-btn').click(handlers.doNothing);
  };



  /**
  * Get the data
  */
  var getData = function() {
    var
      centers_data = mapData;

    center_types        = centers_data.center_types.added;
    colors_legend       = centers_data.center_types.colors.legend;
    centers             = centers_data.markers;
    hide_centers_filter = centers_data.hide_centers_filter;
  };

  return {
    init: initialize
  };

});
